import { render } from "./AuthenticationSettings.vue?vue&type=template&id=5a4c921a"
import script from "./AuthenticationSettings.vue?vue&type=script&lang=js"
export * from "./AuthenticationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__